// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-268fb620]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.el-scrollbar[data-v-268fb620]{height:100%}.has-logo .el-scrollbar[data-v-268fb620]{height:calc(100% - 50px)}.el-menu[data-v-268fb620]{border:none;height:100%;width:100%!important}.el-menu[data-v-268fb620] .el-menu-item{border-left:0 solid #414146}.el-menu[data-v-268fb620] .el-menu-item.is-active{border-left:4px solid #fff;background-color:#343438!important}", ""]);
// Exports
module.exports = exports;
